import { EChartsOption } from "echarts";
import { formatNumberWithSuffix } from "../../../../common/Number";
import { IncomeStatement } from "../../../../types/FinanceTypes";
import { Period } from "../../../../types/SupplierTypes";

enum SeriesName {
    Sold = "Sold",
    Cost = "Cost",
    Margins = "Margins",
}

export interface ChartOptionProps {
    incomes: IncomeStatement[];
    period?: Period;
}

export function getChartOption({
    incomes,
    period = Period.Annually,
}: ChartOptionProps): EChartsOption {
    return {
        tooltip: {
            trigger: "item",
            axisPointer: {
                type: "cross",
            },
        },
        grid: {
            left: 0,
            right: 8,
            top: 4,
            bottom: 0,
            containLabel: true,
        },
        xAxis: [
            {
                type: "category",
                boundaryGap: false,
                data: incomes.map((item, index) => {
                    const isQuterly = period === Period.Quarterly;
                    const label = isQuterly
                        ? `${item.fiscalYear} \n(${item.period})`
                        : item.fiscalYear;
                    const padding =
                        index === 0
                            ? [0, 0, 0, 22]
                            : index === incomes.length - 1
                              ? [0, 22, 0, 0]
                              : 0;
                    return {
                        value: label,
                        textStyle: {
                            padding,
                        },
                    };
                }),
                axisLabel: {
                    color: "#666666",
                    fontSize: 10,
                },
                axisLine: {
                    lineStyle: {
                        color: "#BFBFBF",
                    },
                },
                axisTick: {
                    show: false,
                },
            },
        ],
        yAxis: [
            {
                type: "value",
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#BFBFBF",
                    },
                },
                axisLabel: {
                    color: "#666666",
                    fontSize: 10,
                    formatter: (value: number) => {
                        return formatNumberWithSuffix(value) + "";
                    },
                },
                splitLine: {
                    show: false,
                },
            },
        ],
        series: [
            {
                name: SeriesName.Sold,
                type: "line",
                smooth: false,
                symbol: "none",
                lineStyle: {
                    width: 2,
                    color: "#2FB801",
                },
                data: incomes.map((item) => item.revenue),
            },
            {
                name: SeriesName.Margins,
                type: "line",
                smooth: false,
                symbol: "none",
                lineStyle: {
                    width: 2,
                    color: "#FF981F",
                },
                data: incomes.map((item) => item.grossProfit),
            },
            {
                name: SeriesName.Cost,
                type: "line",
                smooth: false,
                symbol: "none",
                lineStyle: {
                    width: 2,
                    color: "#FD3559",
                },
                data: incomes.map((item) => item.costOfRevenue),
            },
        ],
    };
}
